// src/initCornerstone.js
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import dicomParser from 'dicom-parser';

// Wire externals
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

// Optional: configure loader (CORS, headers, etc.)
cornerstoneWADOImageLoader.configure({
  beforeSend: (xhr) => {
    // xhr.setRequestHeader('x-auth', 'token') // if needed
  },
});

export { cornerstone, cornerstoneTools, cornerstoneWADOImageLoader, dicomParser };
